import { render, staticRenderFns } from "./DashboardInfoWidgets.vue?vue&type=template&id=69ef5c48&scoped=true"
import script from "./DashboardInfoWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardInfoWidgets.vue?vue&type=script&lang=js"
import style0 from "./DashboardInfoWidgets.vue?vue&type=style&index=0&id=69ef5c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ef5c48",
  null
  
)

export default component.exports